export function isPureObject(data) {
    return typeof data === 'object' && !Array.isArray(data) && data !== null;
}
//# sourceMappingURL=object.js.map